import { lazy } from 'react';

const CharityVettingManualContactDetailsEntry = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityVettingManualContactDetails" */ '../components/steps/manual-contact-form-step/ManualContactForm'
    ),
);

export default CharityVettingManualContactDetailsEntry;
